import React, { useState, useMemo, useEffect } from 'react'
import './Descarregamento.scss'
import { Header, Icon, Segment, Button, Modal, Form } from 'semantic-ui-react'
import PageHeader from 'components/PageHeader'
import { useSubscription, arrayShuffle } from 'utils'
import request from 'services/http'
import Barcode from 'react-barcode'
import { map, tap } from 'rxjs/operators'
import InputMask from 'react-input-mask'
import { of } from 'rxjs'

const barcodeOptions = {
    background: 'transparent',
    displayValue: true,
    fontSize: 13,
    margin: 0,
    height: 70,
    width: 1.2
}

const questionsAntesDescarregamento = [
    'Em que momento o gerente foi informado sobre o descarregamento do combustivel? Horas: ____:____',
    'Qual o CNPJ do posto que está na nota fiscal? ___.____.____ / _____ - ___',
    'Quantos litros estão no tanque e quantos litros serão descarregados?<br /> Litros no tanque: ______ Litros a serem descarregados: _____',
    'Quantos cones/placas você utilizou para sinalização? ______',
    'Onde você engatou o cabo de aterramento? __________________________',
    'Quantos lacres estão descritos na nota fiscal? E quantos estão no caminhão?<br /> Qtd. NF ____ Qtd. Caminhão: ____',
    'A massa específica a 20º está entre 0,815 e 0,865? Me informe o resultado: _______',
]

const questionsAposDescarregamento = [
    'Qual o número do tanque você abriu e qual combustível o tanque comporta?<br /> Nº: ______ Combustível: _____________________',
    'Qual combustível estava no caminhão que você descarregou? _____________________',
    'Respeitou a ordem de descarregamento? 1º Etanol, 2º Gasolina, 3º Diesel S500 (Comum), 4º Diesel S10. ________',
    'Em que momento você conferiu se o tanque do caminhão ficou completamente vazio após o descarregamento? Horas: _______</li',
]

function openIndexedDB(database) {
    const conn = indexedDB.open(database)
    conn.onerror = function() {
        alert('Você não habilitou minha web app para usar IndexedDB?!')
    }
    return conn
}

export default function DescarregamentoHome() {

    const [barcode, setBarcode] = useState('0')
    const [printForm, setFormPrint] = useState(false)
    const [hasInternet, setHasInternet] = useState(null)

    const genBarcode$ = useMemo(() =>  request({ method: 'POST', url: '/combustivel/descarregamento/gen-barcode' }).pipe(
        map(({ response }) => setBarcode(response))
    ), [])
    useSubscription(genBarcode$, printForm)

    const loadSuppliers$ = useMemo(() => {
        if (hasInternet !== null) {
            if (hasInternet) {
                return request({ method: 'GET', url: '/common/fornecedores-combustivel' }).pipe(
                    tap(({ response }) => {
                        const conn = openIndexedDB('intranet')
                        conn.onupgradeneeded = function(ev) {
                            const db = ev.target.result
                            const objectStore = db.createObjectStore('fornecedores', { keyPath: 'cnpj' })
                            objectStore.createIndex('cnpj', 'cnpj', { unique: true })
                            objectStore.createIndex('nome', 'nome', { unique: false })
                        }

                        conn.onsuccess = function(ev) {
                            const db = ev.target.result
                            const suppliersObjectStore = db.transaction('fornecedores', 'readwrite').objectStore('fornecedores')
                            const countObjects = suppliersObjectStore.count()
                            countObjects.onsuccess = function() {
                                if (countObjects.result < response.length) {
                                    for (let supplier of response) {
                                        suppliersObjectStore.add(supplier)
                                    }
                                }
                            }
                        }
                    })
                )
            } else {
                const conn = openIndexedDB('intranet')
                conn.onsuccess = function(ev) {
                    if (!ev.target.result.objectStoreNames.contains('fornecedores')) {
                        alert('No momento você está sem conexão com a internet. O primeiro acesso ao módulo de descarregamento necessita de internet para funcionar offline.')
                    }
                }
            }
        }
        return of()
    }, [hasInternet])
    useSubscription(loadSuppliers$)

    useEffect(() => {
        fetch(window.location.origin + '/favicon.ico')
            .then(() => setHasInternet(true))
            .catch(() => setHasInternet(false))
    }, [])

    useEffect(() => {
        if (printForm && barcode !== '0') {
            window.print()
            setFormPrint(false)
            setBarcode('0')
        }
    }, [printForm, barcode])

    return (
        <div id="descarregamento-home">
            <Modal open={false} dimmer='blurring' size='tiny'>
                <Modal.Header style={{ fontSize: 18 }}>
                    <Icon name='print' className='mr-2' />Imprimir Formulário de Descarregamento
                </Modal.Header>
                <Modal.Content>
                    <Form>
                        <Form.Group>
                            <Form.Field>
                                <label>CNPJ do Fornecedor</label>
                                <InputMask mask='99.999.999/9999-99' />
                            </Form.Field>
                            <Form.Field>
                                <span style={{ display: 'inline-block', marginTop: 36, fontSize: 15 }}>IPIRANGA LIMITADA LTDA</span>
                            </Form.Field>
                        </Form.Group>
                        <Form.Group>
                            <Form.Select label='Combustível' className='options-font-size' defaultValue={1} options={[
                                { key: '1', value: 1, text: 'Diesel Comum' }
                            ]} />
                        </Form.Group>
                        <Form.Button icon='print' content='Imprimir' />
                    </Form>
                </Modal.Content>
            </Modal>
            <div className='page-content d-print-none'>
                <PageHeader />

                <Segment className='subcontent'>
                    <Header as='h3' className='mb-3'>
                        <Icon.Group size='big'>
                            <Icon name='truck' className='primary-color' />
                        </Icon.Group>
                        <Header.Content className='primary-color'>
                            Descarregamento <Header.Subheader className='secondary-color'>Descarregamento de combustível</Header.Subheader>
                        </Header.Content>
                    </Header>

                    <div className="row">
                        <div className="col">
                            <div className='d-flex flex-column mt-5'>
                                <Button className='align-self-center mb-3 w-50 orange-rdp' onClick={() => {}}><Icon name='home' /> Início</Button>
                                <Button className='align-self-center mb-3 w-50 orange-rdp' onClick={() => setFormPrint(true)}><Icon name='print' /> Imprimir Formulário</Button>
                                <Button className='align-self-center mb-3 w-50 orange-rdp' onClick={() => {}}><Icon name='lab' /> Lançar Descarregamento</Button>
                                <Button className='align-self-center w-50 blue-rdp' onClick={() => {}}><Icon name='file alternate outline' /> Relatório Geral</Button>
                            </div>
                        </div>
                        <div className="col">
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic, voluptates. Quia perspiciatis, quos asperiores fugiat corporis modi numquam deserunt sequi eum ipsa consequatur, exercitationem provident reprehenderit suscipit, beatae tenetur sapiente.
                        </div>
                    </div>
                </Segment>
            </div>

            <div id="descarregamento-form" className='d-none d-print-block'>
                {/* <h1>Registro de Análise da Qualidade (RESOLUÇÃO ANP Nº 9, DE 7.3.2007)</h1>

                <table>
                    <tbody>
                        <tr>
                            <td colSpan={4} className='sub-header'>MEDIDAS DE TANQUE</td>
                        </tr>
                        <tr>
                            <td className='tiny-header'>ANTES DESCARREGAMENTO</td>
                            <td className='tiny-header'>APÓS DESCARREGAMENTO</td>
                        </tr>
                        <tr>
                            <td style={{ padding: 0, margin: 0, height: 45 }}>
                                <div className='vertical-text'>TANQUE</div>
                                <div></div>
                                <div style={{ marginLeft: 70 }} className='vertical-text'>RÉGUA</div>
                                <div></div>
                                <div style={{ marginLeft: 70 }} className='vertical-text'>LITROS</div>
                            </td>
                            <td style={{ padding: 0, margin: 0, height: 45 }}>
                                <div className='vertical-text'>TANQUE</div>
                                <div></div>
                                <div style={{ marginLeft: 70 }} className='vertical-text'>RÉGUA</div>
                                <div></div>
                                <div style={{ marginLeft: 70 }} className='vertical-text'>LITROS</div>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: 0, margin: 0, height: 45 }}>
                                <div className='vertical-text'>TANQUE</div>
                                <div></div>
                                <div style={{ marginLeft: 70 }} className='vertical-text'>RÉGUA</div>
                                <div></div>
                                <div style={{ marginLeft: 70 }} className='vertical-text'>LITROS</div>
                            </td>
                            <td style={{ padding: 0, margin: 0, height: 45 }}>
                                <div className='vertical-text'>TANQUE</div>
                                <div></div>
                                <div style={{ marginLeft: 70 }} className='vertical-text'>RÉGUA</div>
                                <div></div>
                                <div style={{ marginLeft: 70 }} className='vertical-text'>LITROS</div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table style={{ marginTop: 20 }}>
                    <tbody>
                        <tr>
                            <td colSpan={3} className='sub-header'>DADOS DO POSTO REVENDEDOR</td>
                        </tr>
                        <tr>
                            <td colSpan={2}><b>RAZÃO SOCIAL</b>: REDE DOMPEDRO DE POSTOS LTDA</td>
                            <td><b>CNPJ</b>: 02.814.510/0001-28</td>
                        </tr>
                        <tr>
                            <td colSpan={3}><b>ENDEREÇO</b>: RUA DO TESTE, 93 ABC</td>
                        </tr>
                        <tr>
                            <td><b>BAIRRO</b>: BAIRRO DE TESTE</td>
                            <td><b>CIDADE</b>: ESTIVA</td>
                            <td><b>ESTADO</b>: MG</td>
                        </tr>
                    </tbody>
                </table>

                <table style={{ marginTop: 20 }}>
                    <tbody>
                        <tr>
                            <td colSpan={3} className='sub-header'>DADOS DO RECEBIMENTO</td>
                        </tr>
                        <tr>
                            <td><b>Data da coleta</b>: 24/10/2019</td>
                            <td><b>Produto</b>: Diesel S500</td>
                            <td><b>Nota Fiscal do Produto</b>:</td>
                        </tr>
                        <tr>
                            <td><b>Volume recebido (litros)</b>: </td>
                            <td><b>Distribuidor</b>: ROYAL</td>
                            <td><b>CNPJ do Distribuidor</b>: 02.814.510/0001-28</td>
                        </tr>
                        <tr>
                            <td><b>Transportador</b>: TRANSPORTADORA RDP</td>
                            <td><b>CNPJ do Transp.</b>: 02.814.510/0001-28</td>
                            <td colSpan={2}><b>Placa do Caminhão</b>:</td>
                        </tr>
                        <tr>
                            <td colSpan={2}><b>Nome do Motorista</b>:</td>
                            <td><b>RG do Motorista</b>:</td>
                        </tr>
                        <tr>
                            <td colSpan={3}><b>Nome do Analista</b>:</td>
                        </tr>
                    </tbody>
                </table>

                <table style={{ marginTop: 20 }}>
                    <tbody>
                        <tr>
                            <td colSpan={4} className='sub-header'>RESULTADOS DA ANÁLISE</td>
                        </tr>
                        <tr>
                            <td colSpan={4}>
                                <div>
                                    <b>Legenda de Aspectos</b><br />
                                    I – Límpido e isento de impurezas. II – Límpido e com impureza. III – Turvo e isento de impurezas. IV – Turvo e com impurezas.
                                </div>

                                <div style={{ marginTop: 5 }}>
                                    <b>Considerações de Cor</b>:<br />
                                    Óleo Diesel S500 deve ser Vermelho.
                                </div>

                                <div style={{ marginTop: 5 }}>
                                    <b>Massa Específica a 20ºC do Óleo Disel S500</b>:<br/>
                                    815 a 865 kg/m³
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>Aspecto: </td>
                            <td>Cor: </td>
                            <td>Teor de Álcool: </td>
                        </tr>
                        <tr>
                            <td style={{ width: '33.333%' }}>Densidade: </td>
                            <td style={{ width: '33.333%' }}>Temperatura: </td>
                            <td colSpan={2} style={{ width: '33.333%' }}>Massa Específica a 20ºC:</td>
                        </tr>
                    </tbody>
                </table>

                <table style={{ marginTop: 20 }} id="footer-table">
                    <tbody>
                        <tr>
                            <th style={{ width: '1%', whiteSpace: 'nowrap', padding: 20, verticalAlign: 'middle' }}>Assinatura do Operador</th>
                            <td></td>
                            <td rowSpan={2} style={{ width: 150, verticalAlign: 'middle' }}>
                                <Barcode {...barcodeOptions} value={'F' + barcode} />
                            </td>
                        </tr>
                        <tr>
                            <th style={{ width: '1%', whiteSpace: 'nowrap', padding: 20, verticalAlign: 'middle' }}>Assinatura do Gerente</th>
                            <td></td>
                        </tr>
                    </tbody>
                </table> */}

                <div id="checklist">
                    <h1>LISTA DE CONFERÊNCIA DO PROCESSO (CHECKLIST)</h1>
                    <div className="box">
                        <p><b>ATENÇÃO</b>: É de extrema importancia que as perguntas sejam <b>LIDAS</b> e <b>RESPONDIDAS</b> devidamente. O checklist é utilizado para conferência caso ocorra algum problema no procedimento de descarregamento. Caso as respostas aqui descritas sejam diferentes da realidade, medidas serão tomadas.</p>
                        <p style={{ marginBottom: 0 }}>O checklist não é transcrito p/ o sistema. É realizado o lançamento do formulário preenchido manualmente e assinado.</p>
                    </div>

                    <h2>1 - ANTES DO DESCARREGAMENTO</h2>
                    <ul>
                        {arrayShuffle(questionsAntesDescarregamento).map((q, i) => (
                            <li dangerouslySetInnerHTML={{ __html: q }} key={i}></li>
                        ))}
                    </ul>

                    <h2>2 - APÓS O DESCARREGAMENTO</h2>
                    <ul>
                        {arrayShuffle(questionsAposDescarregamento).map((q, i) => (
                            <li dangerouslySetInnerHTML={{ __html: q }} key={i}></li>
                        ))}
                    </ul>

                    <div className='ask'>Dê uma nota para o motorista que fez o transporte do combustível (1 a 10). Esta nota deve ser preenchida somente após a assinatura do motorista. ________</div>

                    <table style={{ marginTop: 20 }} id="footer-table">
                    <tbody>
                        <tr>
                            <th style={{ width: '1%', whiteSpace: 'nowrap', padding: 20, verticalAlign: 'middle' }}>Assinatura do Operador</th>
                            <td></td>
                            <td rowSpan={2} style={{ width: 150, verticalAlign: 'middle' }}>
                                <Barcode {...barcodeOptions} value={'C' + barcode} />
                            </td>
                        </tr>
                        <tr>
                            <th style={{ width: '1%', whiteSpace: 'nowrap', padding: 20, verticalAlign: 'middle' }}>Assinatura do Gerente</th>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
                </div>
            </div>
        </div>
    )
}
